// 사이드바 묶음(BUSINESS · MANUFACTURING · FIELD · 관리) 색 — 한 벌.
//
// 2026-10-19 오너: 묶음마다 띠 색을 달리하고, 고른 메뉴도 그 색으로 칠한다(Sidebar).
// 2026-10-21 오너: "옆 카테고리 색을 따라서 상단 바 색이 바뀌었으면" — 상단 바(TopBar)도 지금 화면이
// 속한 묶음의 색을 쓴다. 두 곳이 같은 표를 보게 여기로 모았다.

export type NavSection = 'business' | 'manufacturing' | 'field' | 'admin';

export const SECTION_ACCENT: Record<NavSection, string> = {
  business: 'var(--robot-shipping)',
  manufacturing: 'var(--robot-installing)',
  field: 'var(--brand)',
  admin: 'var(--robot-maintenance)',
};

/**
 * 경로 → 묶음. 사이드바 메뉴에 없는 상세 화면도 그 메뉴가 속한 묶음으로 본다
 * (고객사 · 계약 · 딜 · 매장 상세는 고객사 마스터에서, 로봇 상세는 로봇 목록에서 들어온다).
 * 홈(대시보드) 같이 어느 묶음에도 없으면 null — 상단 바는 기본색.
 */
const SECTION_PREFIXES: ReadonlyArray<[NavSection, readonly string[]]> = [
  ['business', ['/business', '/customers', '/contracts', '/deals', '/stores']],
  ['manufacturing', ['/manufacturing', '/robots', '/deployments', '/parts', '/suppliers']],
  ['field', ['/field', '/reports', '/service-orders', '/infrastructure', '/fleet']],
  ['admin', ['/admin', '/privacy-requests', '/audit-logs', '/users']],
];

export function sectionForPath(pathname: string): NavSection | null {
  for (const [section, prefixes] of SECTION_PREFIXES) {
    if (prefixes.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return section;
  }
  return null;
}

/** 흰 글씨가 읽히게 조금 어둡게 섞은 묶음 색 — 사이드바의 고른 메뉴와 같은 칠. */
export function sectionFill(accent: string): string {
  return `color-mix(in srgb, ${accent} 88%, #000)`;
}
